import { useEffect, useState } from 'react';
import { ManagedAccountsApi } from '@/api/clients/managed-accounts/managed-accounts.api';

export const useGetManagedAccountPaymentsManager = (id) => {
  const [managedAccount, setManagedAccount] = useState(null);
  const [loading, setLoading] = useState(Boolean(id));
  const [error, setError] = useState(null);

  useEffect(() => {
    setError(null);
    if (!id) {
      setManagedAccount(null);
      setLoading(false);
      return;
    }

    setLoading(true);

    ManagedAccountsApi.getPaymentsManager(id)
      .then((response) => {
        setManagedAccount(response.data.data);
      })
      .catch((requestError) => {
        setError(
          requestError.response?.data?.message ||
            'Failed to load the managed account',
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  return { managedAccount, loading, error };
};
